import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLQuoteElement extends HTMLElement { constructor(tagName: string = 'BLOCKQUOTE', ownerDocument?: any) { super(tagName, ownerDocument); } }
